import React from 'react';
import {useTranslate} from '@computerrock/formation-i18n';
import {ContentBlock, ContentItem, Icon, infoIcon, phoneIcon, emailIcon, useStyles, Circle, Card} from '@ace-de/ui-components';
import ContactDetailRow from './view-elements/ContactDetailRow';
import {contactInfo} from './constants/contact';
import ContactCard from './view-elements/ContactCard';
import './Maintenance.scss';

const Maintenance = () => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateMaintenance = createTranslateShorthand('maintenance');

    return (
        <div
            className={cx([
                'maintenance-wrapper',
                'global!ace-u-flex',
                'global!ace-u-flex--justify-space-between',
                'global!ace-u-flex--small-direction-column',
            ])}
        >
            <ContentBlock
                className={cx([
                    'global!ace-u-height--full',
                    'global!ace-u-flex',
                    'global!ace-u-flex--align-center',
                    'global!ace-u-flex--justify-center',
                ])}
            >
                <ContentItem
                    className={cx([
                        'ace-c-content-item--base-span-12',
                        'ace-c-content-item--small-span-8',
                        'ace-c-content-item--large-span-6',
                        'ace-c-content-item--x-large-span-6',

                    ])}
                >
                    <Card
                        className={cx([
                            'global!ace-u-padding--small-16',
                            'global!ace-u-padding--x-large-32',
                            'global!ace-u-flex--align-center',
                            'global!ace-u-flex--justify-center',
                            'ace-c-card--variant-white',
                        ])}
                    >
                        <Circle className={cx('global!ace-u-margin--small-bottom-16')}>
                            <Icon
                                icon={infoIcon}
                                className={cx([
                                    'ace-c-icon--xl',
                                    'ace-c-icon--color-highlight',
                                ])}
                            />
                        </Circle>
                        <h2
                            className={cx([
                                'global!ace-u-typography--variant-h2',
                                'global!ace-u-margin--small-bottom-0',
                                'global!ace-u-margin--x-large-bottom-8',
                                'global!ace-u-typography--align-center',
                            ])}
                        >{translateMaintenance('section_title.maintenance')}
                        </h2>
                        <h3
                            className={cx([
                                'global!ace-u-typography--variant-h3',
                                'global!ace-u-margin--x-large-bottom-32',
                                'global!ace-u-margin--small-bottom-24',
                                'global!ace-u-typography--align-center',
                            ])}
                        >
                            {translateMaintenance('section_message.maintenance_on')}<br />
                            {translateMaintenance('section_message.try_later')}<br />
                            {translateMaintenance('section_message.signature')}
                        </h3>
                    </Card>
                </ContentItem>
            </ContentBlock>
            <ContactCard
                className={cx('global!ace-u-flex')}
            >
                <h3
                    className={cx([
                        'global!ace-u-typography--variant-body-large',
                        'global!ace-u-margin--small-bottom-24',
                        'global!ace-u-margin--x-large-bottom-0',
                        'global!ace-u-margin--x-large-right-48',
                    ])}
                >
                    {translateMaintenance('title.contact_member_service')}
                </h3>
                <ContactDetailRow>
                    <Icon
                        className={cx(['ace-c-icon--m', 'ace-c-icon--color-highlight', 'global!ace-u-margin--right-8'])}
                        icon={emailIcon}
                    />
                    <a
                        href={contactInfo.mail.link}
                        className={cx(['global!ace-u-typography--variant-body-large'])}
                        data-qa="contact-email-link"
                    >{translateMaintenance('title.email')} {contactInfo.mail.text}
                    </a>
                </ContactDetailRow>
                <div className={cx(['global!ace-u-margin--bottom-16', 'global!ace-u-margin--x-large-right-48'])} />
                <ContactDetailRow>
                    <Icon
                        className={cx(['ace-c-icon--m', 'ace-c-icon--color-highlight', 'global!ace-u-margin--right-8'])}
                        icon={phoneIcon}
                    />
                    <a
                        href={contactInfo.phone.link}
                        className={cx(['global!ace-u-typography--variant-body-medium'])}
                        data-qa="contact-phone-link"
                    >{translateMaintenance('title.phone_number')} {contactInfo.phone.text}
                    </a>
                </ContactDetailRow>
            </ContactCard>
        </div>
    );
};

export default Maintenance;
